import { Payment as AvailablePayment } from '@/models/api/payment/payment'
import { PaymentType } from '@/models/app-config/behavior/types'
import { CreditcardModel } from '@spa/store/modules/creditcard/types'
import { PaymentWithApiPayment } from '@spa/store/modules/orderConfirm/types'

export function buildCreditcardPayment(
  availablePayment: AvailablePayment,
  creditCard: CreditcardModel
): PaymentWithApiPayment {
  return {
    payment_type: availablePayment.id,
    token: creditCard.id,
    numberLast4: creditCard.numberLast4,
    cardType: creditCard.cardType,
    lastCreditDate: creditCard.lastCreditDate,
    apiPayment: availablePayment,
  }
}

export type PaymentTypeWithStaticValue = Extract<
  PaymentType,
  'cash-on-delivery' |
  'np-postpay' |
  'atone' |
  'paidy'
>
export function buildWithStaticValue(
  paymentType: PaymentTypeWithStaticValue,
  availablePayment: AvailablePayment
): PaymentWithApiPayment {
  /*
   * client/spa/src/store/modules/orderConfirm/mutations.ts
   * 上記 mutation で設定している値と一致する必要がある.
   *
   * 最終的に初期化および設定値はこのモジュールに集約し、mutation/dispatchは単一I/Fにする想定.
   */
  switch (paymentType) {
    case 'cash-on-delivery':
      return {
        payment_type: 'cash-on-delivery',
        apiPayment: availablePayment,
      }
    case 'np-postpay':
      return {
        payment_type: 'np-postpay',
        apiPayment: availablePayment,
      }
    case 'atone':
      return {
        payment_type: 'atone',
        paymentid: '',
        auth_token: '',
        apiPayment: availablePayment,
      }
    case 'paidy':
      return {
        payment_type: 'paidy',
        paymentid: '',
        apiPayment: availablePayment,
      }
  }
}
